import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CloseIcon, TrashIcon, CheckCircleIcon, ClipIcon, ClockIcon, HashIcon, UploadIcon } from '../shared/icons';
import { DOWNLOAD_BL_FILE } from 'Constants/actionConstants';
import styles from './index.module.scss';

class ViewBLDocumentsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blDocs: props.doc ? [...(props.doc.blDocs || [])] : [],
      downloadingId: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.doc !== this.props.doc) {
      this.setState({ blDocs: this.props.doc ? [...(this.props.doc.blDocs || [])] : [] });
    }
  }

  handleDelete = (id) => {
    if (this.props.onDelete) this.props.onDelete(id);
    this.setState(prev => ({ blDocs: prev.blDocs.filter(d => d.id !== id) }));
  };

  handleDownload = (bl) => {
    if (this.state.downloadingId) return;
    this.setState({ downloadingId: bl.id });
    this.props.dispatch({
      type: DOWNLOAD_BL_FILE,
      fileName: bl.attachment,
      onSuccess: () => this.setState({ downloadingId: null }),
      onError: () => this.setState({ downloadingId: null }),
    });
  };

  render() {
    const { rfq, doc, onClose, onUploadBL } = this.props;
    const { blDocs, downloadingId } = this.state;
    const count = blDocs.length;

    return (
      <div className={styles.overlay} onClick={onClose}>
        <div className={styles.modal} onClick={e => e.stopPropagation()}>
          <div className={styles.header}>
            <span className={styles.title}>Bill of Lading Documents</span>
            <button className={styles.closeBtn} onClick={onClose}><CloseIcon /></button>
          </div>
          <div className={styles.subtitle}>
            {doc && <><span>Doc: {doc.name}</span> &nbsp;·&nbsp; </>}
            RFQ {rfq.rfqNumber}
          </div>

          {count > 0 && (
            <div className={styles.countBanner}>
              <CheckCircleIcon /> {count} BL{count !== 1 ? 's' : ''} uploaded
            </div>
          )}

          <div className={styles.docList}>
            {count === 0 ? (
              <div className={styles.emptyState}>No BL documents uploaded yet.</div>
            ) : (
              blDocs.map((bl, idx) => (
                <div key={bl.id} className={styles.blCard}>
                  <div className={styles.blNum}>{idx + 1}</div>

                  <div className={styles.blFields}>
                    <div className={styles.blField}>
                      <div className={styles.blFieldLabel}><HashIcon /> BL Number</div>
                      <div className={styles.blFieldValue}>{bl.blNumber}</div>
                    </div>
                    <div className={styles.blField}>
                      <div className={styles.blFieldLabel}><ClipIcon /> Attachment</div>
                      <div className={styles.blAttachment}>
                        <button
                          className={styles.blAttachmentLink}
                          onClick={() => this.handleDownload(bl)}
                          disabled={downloadingId === bl.id}
                        >
                          {downloadingId === bl.id ? 'Downloading...' : bl.attachment}
                        </button>
                        {bl.size && <span className={styles.blSize}>· {bl.size}</span>}
                      </div>
                    </div>
                    <div className={styles.blField}>
                      <div className={styles.blFieldLabel}><ClockIcon /> Uploaded</div>
                      <div className={styles.blUploadedDate}>{bl.uploadedAt}</div>
                    </div>
                  </div>

                  <button className={styles.deleteBtn} onClick={() => this.handleDelete(bl.id)}>
                    <TrashIcon /> Delete
                  </button>
                </div>
              ))
            )}
          </div>

          <div className={styles.footer}>
            <button className={styles.closeBtn2} onClick={onClose}>Close</button>
            <button className={styles.uploadBLBtn} onClick={() => { onClose(); if (onUploadBL) onUploadBL(); }}>
              <UploadIcon size={14} /> Upload BL
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(ViewBLDocumentsModal);
